
export const securityQuestionsConstants={
    GET_SECURITYQUESTIONS_LIST_REQUEST:"GET_SECURITYQUESTIONS_LIST_REQUEST",
    GET_SECURITYQUESTIONS_LIST_SUCCESS:"GET_SECURITYQUESTIONS_LIST_SUCCESS",
    GET_SECURITYQUESTIONS_LIST_FAILURE:"GET_SECURITYQUESTIONS_LIST_FAILURE", 
//add
    ADD_SECURITYQUESTIONS_LIST_REQUEST:"ADD_SECURITYQUESTIONS_LIST_REQUEST",
    ADD_SECURITYQUESTIONS_LIST_SUCCESS:"ADD_SECURITYQUESTIONS_LIST_SUCCESS",
    ADD_SECURITYQUESTIONS_LIST_FAILURE:"ADD_SECURITYQUESTIONS_LIST_FAILURE", 

    UPDATE_SECURITYQUESTIONS_REQUEST:"UPDATE_SECURITYQUESTIONS_REQUEST",
    UPDATE_SECURITYQUESTIONS_SUCCESS:"UPDATE_SECURITYQUESTIONS_SUCCESS",
    UPDATE_SECURITYQUESTIONS_FAILURE:"UPDATE_SECURITYQUESTIONS_FAILURE",

    UPDATE_SECURITYQUESTIONSSTATUS_REQUEST:"UPDATE_SECURITYQUESTIONSSTATUS_REQUEST",
    UPDATE_SECURITYQUESTIONSSTATUS_SUCCESS:"UPDATE_SECURITYQUESTIONSSTATUS_SUCCESS",
    UPDATE_SECURITYQUESTIONSSTATUS_FAILURE:"UPDATE_SECURITYQUESTIONSSTATUS_FAILURE",

    DELETE_SECURITYQUESTIONS_REQUEST:"DELETE_SECURITYQUESTIONS_REQUEST",
    DELETE_SECURITYQUESTIONS_SUCCESS:"DELETE_SECURITYQUESTIONS_SUCCESS",
    DELETE_SECURITYQUESTIONS_FAILURE:"DELETE_SECURITYQUESTIONS_FAILURE",
}